import { memo } from "react";
import Tippy from "@tippyjs/react";

const ToolTipIcon = ({ tipContent }) => {
  const content = tipContent ? tipContent : "Es gibt keine weitere Info";

  return (
    <Tippy content={content} placement="top-start">
      <i className="fa fa-info-circle custom-info-circle" />
    </Tippy>
  );
};

export default memo(ToolTipIcon);
